import React, { PureComponent } from 'react'
import { createPortal } from 'react-dom'
import { string, func } from 'prop-types'
import { withI18n } from '@active/react-utils/i18n'
import Alert from '@active/react-ui/Alert'
import { getRootElement } from '@active/react-ui/config'

import './ErrorContent.scss'

const ERROR_MSG_CONTAINER_ID = 'passportAppGloalErrorMsg'
const defaultError = 'passport.error.server.default'

const icons = ['success', 'warning', 'danger', 'info'] // error should be dafault to danger

class ErrorContent extends PureComponent {
  static propTypes = {
    i18n: func.isRequired,
    errorMsg: string,
    messageType: string,
  }

  static defaultProps = {
    errorMsg: undefined,
    messageType: '',
  }

  constructor(props) {
    super(props)

    this.state = {
      target: null,
    }
  }

  componentDidMount() {
    this.setState({
      target: getRootElement().querySelector(`#${ERROR_MSG_CONTAINER_ID}`),
    })
  }

  render() {
    const { messageType, errorMsg, i18n } = this.props
    const { target } = this.state
    if (target && typeof errorMsg === 'string') {
      const code = errorMsg || defaultError
      const message = decodeURIComponent(i18n(code))
      const msgType = icons.find(i => i === (messageType && messageType.toLowerCase())) || 'danger'

      return (
        createPortal((
          <Alert type={msgType} theme="inline" className="error-content">
            <span
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: message }}
            />
          </Alert>
        ), target)
      )
    }
    return null
  }
}

export default withI18n(ErrorContent)
